export default {
  SET_INGREDIENTS(state, ingredients) {
    state.ingredients = ingredients;
  },
  SET_INGREDIENT_CATEGORIES(state, category) {
    state.ingredientCategories = category;
  },
};
